import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './item.styl'

export default class LogItem extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.item}>
        {this.props.children}
      </div>
    )
  }
}
